import * as React from "react";
const Exposure = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19,4 C19.5522847,4 20,4.44771525 20,5 L20,19 C20,19.5522847 19.5522847,20 19,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,5 C4,4.44771525 4.44771525,4 5,4 L19,4 Z M19,5 L5,5 L5,19 L19,5 Z M18,15 L13,15 L13,16 L18,16 L18,15 Z M9,6 L9,8 L11,8 L11,9 L9,9 L9,11 L8,11 L8,9 L6,9 L6,8 L8,8 L8,6 L9,6 Z" }));
Exposure.displayName = "Exposure";
var Exposure_default = Exposure;
export {
  Exposure_default as default
};
